"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakpoint = exports.TileVersion = void 0;
/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
var TileVersion;
(function (TileVersion) {
    TileVersion["S"] = "S";
    TileVersion["L"] = "L";
    TileVersion["XL"] = "XL";
    TileVersion["FourColumns"] = "4-columns";
    TileVersion["FiveColumns"] = "5-columns";
})(TileVersion = exports.TileVersion || (exports.TileVersion = {}));
var Breakpoint;
(function (Breakpoint) {
    Breakpoint["XS"] = "xs";
    Breakpoint["SM"] = "sm";
    Breakpoint["MD"] = "md";
    Breakpoint["LG"] = "lg";
    Breakpoint["XL"] = "xl";
    Breakpoint["XXL"] = "xxl";
})(Breakpoint = exports.Breakpoint || (exports.Breakpoint = {}));
//# sourceMappingURL=Tile.contracts.js.map